export default "__VITE_ASSET__9t9xL_uk__"